import {BaseEntity} from "./BaseEntity";

export class Template implements BaseEntity {
    constructor(public id?:number,
                public name?:string,
                public templateType:string="Asset",
                public printMethod:string="Bartender",
                public fileName?:string,
                public useWithService?: string,
                public printClientID?:number) {
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;
        this.templateType = json.templateType;
        this.printMethod = json.printMethod;
        this.fileName = json.fileName;
        this.useWithService = json.useWithService;
        this.printClientID = json.printClientID;
    }
}
